module.exports = __webpack_public_path__ + "static/heroslide-8-175ca9acd608c4a01bc74833e1676828.jpeg";